import Main from '../common/Main/Main';

export const Layout = ({ children, marginsMain = true }) => (
    <div data-testid={"layout-component"}>
        <Main>
            {/* reemplazar por header */}
            <div style={{ height: '60px', lineHeight: '60px', borderBlockEnd: 'red' }}>
                <a href="/">
                    <img src="/images/logo-propiedades.svg" alt="logo propiedades" />
                </a>
            </div>
        </Main>
        {
            marginsMain ? (
                <Main>
                    {children}
                </Main>
            ) : (
                <>{children}</>
            )
        }
    </div>
);
